module.exports = __webpack_public_path__ + "f394b7e90285228ef6d993ebf0b79632.pdf";